import AbstractGuestlistDetailsPageController from './abstract-details-controller';

export default class GuestlistLimitsPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);
        this.growl = this.injector.get('growl');
        this.queue = this.injector.get('$q');
        this.filter = this.injector.get('$filter');
        this.lodash = _;
        this.alert = this.injector.get('Alert');
        this.deposit = this.injector.get('Deposit');
        this.rsvpsBaseStore = this.injector.get('Rsvps');

        this.guestlist = null;
        this.originalGlLimits = null;
        this.loadingInformation = true;
        this.currentLimitInformation = [];
        this.currentSelectedAddField = null;
        this.guestlistFields = {};
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this._loadInformation()
            .finally(() => {
                this.loadingInformation = false;
            })
    }

    goToEdit() {
        this.state.go('app.guestlists.rsvps.edit-settings', {
            gid: this.guestlist.id,
            editorView: 'limitations::field_limits'
        });
    }

    /* Private functions */
    _loadInformation() {
        return this.queue.all([
            this.api.get(`guestlists/${this.stateParams.gid}/limits`).then((response) => {
                this.originalGlLimits = response.data.data;
            }, () => {
                this.growl.error('Error while loading current limit information');
            }),
            this.api.get(`guestlists/${this.stateParams.gid}/fields`).then((response) => {
                this.guestlistFields = response.data.data
            }, () => {
                this.growl.error('Error while loading current limit information');
            })
        ]).then(() => {
            this.currentLimitInformation = this._readLimitsFromApi(this.originalGlLimits);
        });
    }

    _readLimitsFromApi(apiData) {
        let currentLimitInformation = [];
        _.each(apiData, (limits, field) => {
            const glField = _.get(this.guestlistFields, field),
                newLimitEntry = {
                    key: field,
                    field: glField,
                    limits: []
                };

            _.each(limits, (limitInformation, value) => {
                if (glField && glField.enum && _.isUndefined(glField.enum[value])) {
                    return;
                }
                newLimitEntry.limits.push({
                    ...limitInformation,
                    value: value
                })
            });

            if (glField && glField.enum) {
                _.each(glField.enum, (label, key) => {
                    if (this.filter('filter')(newLimitEntry.limits, {value: key}).length === 0) {
                        newLimitEntry.limits.push({
                            value: key,
                            current: 0,
                            limit: -1
                        });
                    }
                });
            }

            currentLimitInformation.push(newLimitEntry);
        });

        return currentLimitInformation;
    }

    goToRsvpListAndFilter(limitField, value) {
        let key = limitField.key.replace('rsvp.', '');
        const store = this.rsvpsBaseStore.create('GuestlistView' + this.guestlist.id);

        const visibleFields = store.state.visible;
        if (visibleFields.indexOf(key) === -1) {
            visibleFields.push(key);
            store.commit('setVisible', visibleFields);
        }

        store.commit('setFilter', {
            key: key,
            value: [value]
        });

        store.dispatch('saveState');

        this.state.go('app.guestlists.rsvps.index', {
            gid: this.guestlist.id,
            store: store
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/limits-controller.js